(function LivePlannerCollections($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/LivePlanner/collectionsList/', function onload()
		{
			$('.preview-link').click(function _preview(e) {
				var url    = $(this).data('url'),
					$modal = $('.modal');

				e.preventDefault();

				$modal.find('.modal-title').text("Preview");
				$(".modal-dialog").addClass('modal-lg');
				$modal.find('.modal-body').html('<iframe src="' + url + '" style="border:none; width: 100%; height: 1080px" credentialless></iframe>');

				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});
		});

		Adzuki.onload('/LivePlanner/collectionPreview/', function onload()
		{
			$('.lp-collection-item-extra-video').on('click', function _showContentDetail(e) {
				var $modal      = $('#modalWindow'),
				    description = $(this).data('description'),
				    name        = $(this).data('name'),
				    embed_code  = $(this).data('embed-code'),
				    content     = '';

				e.preventDefault();

				if (embed_code) {
					content += '<div class="embed-responsive embed-responsive-16by9">' + $(this).data('embed-code') + '</div>';
				} else if (description) {
					content += description;
				}

				$modal.find('.modal-title').text(name);
				$modal.find('.modal-body').html(content);

                $modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
                }).modal('show');
			});

		});
	});
}(jQuery, window.Adzuki || {}));
